// Es la api que se usa para los scripts de calculos de pantalla. No se usa en la aplicación
export default function calcApiFactory(ecNotificationsService, flash) {
  const calc = {
    PRECISION_2: 2,
    PRECISION_3: 3,
    PRECISION_4: 4,
    PRECISION_5: 5,
    PRECISION_6: 6,

    // format
    number: toNumber, // NaN, undefined, '...' => 0
    int: toInt, // int(val)
    float: toFloat, // float(val) || float(val,2) => 0,01
    abs: toAbsoluteNumber, //abs number

    // operaciones
    percentage, // percentage(p) => p/100 || percentage(p, val) => val*p%

    sub, // sub(val1, val2) => val1 - val2
    sum, // sum(val, ...valn) => val + ... + valn
    div, // div(val, divider) => val/divider
    mul, // mul(val, ...valn) => val * ... * valn

    roundNumber, //Funcion roundNumber del antiguo viewer
    roundToEven, //Función que redondea al par más cercano

    forEach, // forEach(CAB.LIN , function(LIN){ /*...*/ });
    cumule, // CAB.TOTALNETO = cumule(CAB.LIN, function(LIN){ return LIN.CANTIDAD * LIN.NETO});
    resetArray, // (array) permite borrar un array /!\ sin borrar su referencia
    removeFromArray, // (array, callback(item)) borra todos los elemetos de un array cuando el callback return true

    transformRepetitionsToArray, //(register, keys, max)

    isNumber, //isNumber(n) => boolean

    findListValue, // Permite realizar búsquedas en listas (basadas en equivList)

    flash,
  };

  Object.assign(calc, ecNotificationsService);
  return calc;

  function toNumber(val) {
    return parseFloat(val) || 0;
  }

  function toInt(val) {
    return parseInt(val) || 0;
  }

  function toFloat(val, dec) {
    if (dec && typeof dec === 'number') {
      return parseFloat(val, dec);
    }
    return toNumber(val);
  }

  function sum() {
    return Array.prototype.slice.call(arguments).reduce(function(sum, value) {
      return sum + toNumber(value);
    }, 0);
  }

  function mul() {
    return Array.prototype.slice.call(arguments).reduce(function(mul, value) {
      return mul * toNumber(value);
    }, 0);
  }

  function div(val, divider) {
    divider = divider || 1;
    return toNumber(val) / parseFloat(divider);
  }

  function sub(val, val2) {
    return toNumber(val) / toNumber(val2);
  }

  function percentage(per, val) {
    per = per || 0;
    if (isNumber(val)) {
      return (val * per) / 100;
    }
    return per / 100;
  }

  function cumule(items, callback) {
    if (!Array.isArray(items)) {
      return 0;
    }
    return items.reduce(function(sum, item) {
      return sum + callback(item);
    }, 0);
  }

  /**
   * Funcion recuperada del antiguo viewer.
   */
  function roundNumber(valor, rlength) {
    if (!valor || isNaN(valor)) {
      return 0;
    }
    if (rlength > 0) {
      try {
        return +`${Math.round(`${valor}e+${rlength}`)}e-${rlength}`;
      } catch (e) {
        return Math.round(valor * Math.pow(10, rlength)) / Math.pow(10, rlength);
      }
    } else {
      return valor;
    }
  }

  /* función que redondea al para mas cercano*/
  function roundToEven(n, decimals = 2.0) {
    if (isNaN(n) || isNaN(decimals)) {
      return 0;
    }

    const value = (Math.round((n * Math.pow(10, decimals)) / 2) * 2) / Math.pow(10, decimals);

    return value;
  }

  function forEach(items, callback) {
    if (Array.isArray(items)) {
      items.forEach(callback);
    } else if (typeof items === 'object') {
      flatmap(items, callback);
    }
  }

  function flatmap(items, callback) {
    return Object.keys(items).forEach(key => callback(items[key], key));
  }

  function removeFromArray(items, callback) {
    for (let i = 0; i < items.length; i++) {
      const isRemove = callback(items[i]);
      if (isRemove) {
        items.splice(i, 1);
        i--;
      }
    }
  }

  function resetArray(arr) {
    if (!Array.isArray(arr)) {
      return [];
      // @odeniel: "arr = [];"" no sirve si no se usa como "CAB.LIN = resetArray(CAB.LIN)" ya que sino no tenemos la referencia, ademas ahora es inutil.
    }
    // borra un array sin quitar su referencia
    arr.splice(0, arr.length);
    return arr;
  }

  function transformRepetitionsToArray(register, keys, max) {
    //transforma ...TIPO1, PIMP1, TIPO2, PIMP2,... en [{TIPO, PIMP}, {TIPO, PIMP}]
    //transformRepetitionsToArray(LIN, ['TIPO', 'PIMP'], 2)

    var arr = [],
      MIN_OCCURS = 1,
      MAX_OCCURS = max || 3;
    //var keys=['TIPOIMP', 'TOTIMPU', 'PIMP']
    for (var j = MIN_OCCURS; j <= MAX_OCCURS; j++) {
      var objKeys = {};
      keys.forEach(function(key) {
        objKeys[key] = key + j;
      });
      arr.push(createObject(objKeys, register));
    }
    return arr;

    function createObject(keys, objOrigin) {
      /*
        createObject({
          TIPOIMP: 'TIPOIMP'+j,
          TOTIMPU: 'TOTIMPU'+j,
          PIMP: 'PIMP'+j,
        }, LIN)
        */
      return Object.keys(keys).reduce(function(acc, key) {
        createProperty(acc, key, objOrigin, keys[key]);
        return acc;
      }, {});

      function createProperty(obj, prop, objOrigin, keyOrigin) {
        Object.defineProperty(obj, prop, {
          get: function() {
            return objOrigin[keyOrigin];
          },
          set: function(val) {
            objOrigin[keyOrigin] = val;
          },
        });
      }
    }
  }

  function toAbsoluteNumber(value) {
    if (isNaN(value)) {
      return 0;
    }
    return Math.abs(value);
  }

  function findListValue(list, value) {
    let result;

    if (list && Array.isArray(list.data)) {
      // Buscamos una solución compatible con IE
      let len = list.data.length;

      while (len--) {
        if (list.data[len][list.key] === value) {
          result = list.data[len][list.result || list.key];
          break;
        }
      }
    }

    return result;
  }

  function isNumber(n) {
    return !isNaN(n) && Number(n) === n;
  }
} // fin service
